import { render } from "./SkillSection.vue?vue&type=template&id=1c6f0f6b&scoped=true"
import script from "./SkillSection.vue?vue&type=script&lang=js"
export * from "./SkillSection.vue?vue&type=script&lang=js"

import "./SkillSection.vue?vue&type=style&index=0&id=1c6f0f6b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6f0f6b"]])

export default __exports__